<div class="card" *blockUI="'section-block'">
    <div class="row">
        <div class="row col-12 mb-50 mt-1 justify-content-between">
            <div class="ml-1">
                <button class="btn btn-primary ml-1" rippleEffect (click)="toggleSidebar('create-request',null)">
                    <i data-feather="plus" class="d-sm-none d-inline-block mr-0 mr-sm-1"></i><span
                        class="d-none d-sm-inline-block">Talep Ekle</span>
                </button>
            </div>

            <div class="custom-control custom-control-danger custom-switch mb-1 mr-1 ">
                <input type="checkbox" checked class="custom-control-input" id="customSwitch5" [(ngModel)]="isSwitch"
                    (change)="onSwitchChange($event)" />
                <label class="custom-control-label" for="customSwitch5">Tamamlananları göster</label>
            </div>
        </div>
        <div class="row d-flex justify-content-between col-md-6 col-12">
            <div class="align-items-center ml-1">
                <label class="d-flex align-items-center ml-1">
                    <select class="form-control" [(ngModel)]="basicSelectedOption" (ngModelChange)="onOptionChange()">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="50">50</option>
                    </select>
                </label>
            </div>

            <div>
                <label class="d-flex align-items-center">
                    <select class="form-control" [(ngModel)]="selectedDate" (ngModelChange)="onOptionDateChange()">
                        <option value="null">Tarih Seç</option>
                        <option [value]="today">Bugün</option>
                        <option [value]="lastWeek">Son 1 Hafta</option>
                        <option [value]="lastMonth">Son 1 Ay</option>
                        <option [value]="lastThreeMonths">Son 3 Ay</option>
                        <option [value]="lastSixMonths">Son 6 Ay</option>
                        <option [value]="lastYear">Son 1 Yıl</option>
                    </select>
                </label>
            </div>
        </div>
        <div class="col-md-6 col-12 d-flex justify-content-md-end">
            <div class="d-flex align-items-center justify-content-end">
                <label class="d-flex align-items-center">
                    <input type="search" placeholder="Bul" class="form-control" (keyup)="filterUpdate($event)"
                        (search)="filterUpdate($event)" />
                </label>
            </div>
        </div>
    </div>
    <ngx-datatable [rows]="rows" [rowHeight]="50" class="bootstrap core-bootstrap"  style="cursor: pointer;" [messages]="{ 
        emptyMessage: 'Veri Yok',
        totalMessage: 'Toplam', 
        selectedMessage: 'Seçili'
      }" [limit]="selectedSize" [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50"
        [scrollbarH]="true" (activate)="onActivate($event)">

        <ngx-datatable-column name="No" prop="no" [width]="100"></ngx-datatable-column>
        
        <ngx-datatable-column name="Talep Adı" [width]="300">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.title | slice:0:20 }}{{ row.title.length > 20 ? '...' : '' }}
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Firma Adı" [width]="300">
            <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row.companyName | slice:0:30 }}{{ row.companyName.length > 30 ? '...' : '' }}
            </ng-template>
        </ngx-datatable-column>
      
        <ngx-datatable-column name="Durumu" [width]="200">
            <ng-template ngx-datatable-cell-template let-row="row">
                <div [ngClass]="getStatusClass(row.status)">
                    {{ getStatusText(row.status) }}
                </div>
            </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
            <ng-template ngx-datatable-footer-template>
                <div class="datatable-footer-inner">
                    <div class="page-count">
                        Toplam Veri {{ totalCount }}
                    </div>
                    <ngb-pagination [collectionSize]="(totalCount / basicSelectedOption) * 10" [(page)]="pageBasic"
                        (pageChange)="onPageChange($event)">
                        <ng-template ngbPaginationPrevious>
                            <span [data-feather]="'chevron-left'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                        <ng-template ngbPaginationNext>
                            <span [data-feather]="'chevron-right'" [size]="18" [class]="'font-weight-bolder'"></span>
                        </ng-template>
                    </ngb-pagination>
                </div>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
    <core-sidebar class="modal modal-slide-in sidebar-todo-modal fade" name="create-request"
        overlayClass="modal-backdrop">
        <app-request-task-create [requestTaskId]="requestTaskId"></app-request-task-create>
    </core-sidebar>
</div>